<template>
  <button
    class="btn btn--squared btn--outline-primary mobile-only header__burger"
    :class="{ 'header__burger--active': isOpen }"
    @click="$emit('toggle')"
  >
    <span class="header__icon-wrapper" v-show="!isOpen">
      <img src="~/images/menu.svg" class="btn__icon" alt="Меню" v-svg-inline>
    </span>
    <span class="header__icon-wrapper" v-show="isOpen">
      <img src="~/images/close.svg" class="btn__icon" alt="Закрыть" v-svg-inline>
    </span>
  </button>
</template>

<script setup>
defineProps({
  isOpen: {
    type: Boolean,
    required: true
  }
})

defineEmits(['toggle'])
</script>